import React from "react";

var AuthDetailContext = React.createContext(null);
export const AuthProvider = ({ children }) => {
}

export default AuthDetailContext;